import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { DemoPage } from '../pages/DemoPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/demo')({
  component: Demo,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (isAuthenticated) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
})

function Demo() {
  const navigate = useNavigate()

  const handleLoginSuccess = () => {
    navigate({ to: '/dashboard' })
  }

  return (
    <DemoPage
      onLoginSuccess={handleLoginSuccess}
    />
  )
}
